module.exports = __webpack_public_path__ + "img/20.4c5d5c10.svg";